function initSlickOnce(root = document) {
  if (!window.$) return;
  const sel = '.powerstep-slider';
  const $el = window.$(sel, root);
  if (!$el.length) return;

  if ($el.hasClass('slick-initialized')) $el.slick('unslick');

  $el.slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    draggable: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 575, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 370, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  });
}

if (!customElements.get('powerstep-modal')) {
  class PowerstepModal extends HTMLElement {
    constructor() {
      super();

      this.modal = this; 
      this.closeButtons = this.querySelectorAll('[data-close-modal]');
      
      this.recommendationsSlider = this.querySelector('.powerstep__product-grid .powerstep-slider');
      this.recommendationsHeading = this.querySelector('.powerstep__recommendations-heading');
      this.powerstepRecommendationSlideTemplate = this.querySelector('#powerstep-recommendation-slide-template');
      
      this.addedItemContainer = this.querySelector('.powerstep__added-item');
      this.overlayEl = this.querySelector('.powerstep-modal__overlay');
      this.scrollableEl = this.querySelector('.powerstep-modal__content--scrollable');
      this.quantityMinusButton = this.querySelector('.quantity-selector__button--minus');
      this.quantityPlusButton = this.querySelector('.quantity-selector__button--plus');
      this.quantityEl = this.querySelector('.quantity-selector__quantity');
      this.imageEl = this.querySelector('.powerstep__added-item-image img');
      this.titleEl = this.querySelector('.powerstep__added-item-title');
      this.priceEl = this.querySelector('.powerstep__added-item-price');
      this.removeItemPowerstepButton = this.querySelector('.remove-from-cart');
      this.powerstepControls = this.querySelector('.powerstep__added-item-controls');
      this.quantitySelectorEl = this.powerstepControls.querySelector('.powerstep__quantity-selector');
      this.selectorPowerstepScript = this.quantitySelectorEl.querySelector('.powerstep-data');
      this.quantityInput = this.quantitySelectorEl.querySelector('[name="quantity"]');
      this.productIdInput = this.quantitySelectorEl.querySelector('[name=product-id]');
      this.variantIdInput = this.quantitySelectorEl.querySelector('[name=id]');

      this.progressBarContainer = this.querySelector('.powerstep__progress');
      this.progressBarInfo = this.progressBarContainer?.querySelector('.powerstep__progress-info');
      this.progressBarEl = this.progressBarContainer?.querySelector('.powerstep__progress-bar');
      this.progressBarFillEl = this.progressBarEl?.querySelector('.powerstep__progress-fill');

      this.debounceDelay = 1000;
      this.addToCartDebounceTimer = null;
      this.prevPowerstepProduct = null;
      this.prevPowerstepQuantity = null;
      this.freeShippingThreshold = Number(this.getAttribute('data-free-shipping-threshold'));
      this.progressFill = 0;
      this.openCartButton = this.querySelector('.powerstep-modal__footer .button--secondary');
      this.continueShoppingButton = this.querySelector('.powerstep-modal__footer .button--primary');
    }

    connectedCallback() {
      this.handleProductAdded = this.handleProductAdded.bind(this);
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.addToCart = this.addToCart.bind(this);
      this.handleQuantitySelector = this.handleQuantitySelector.bind(this);
      this.updateCartQuantity = this.updateCartQuantity.bind(this);
      this.handleCartItemRemove = this.handleCartItemRemove.bind(this);
      
      document.addEventListener('product:added', this.handleProductAdded);
      document.addEventListener('powerstep-modal:build', this.handleProductAdded);
      this.openCartButton?.addEventListener('click', (e) => this.close(e));
      this.continueShoppingButton?.addEventListener('click', (e) => this.close(e, 'close-cart'));
      this.removeItemPowerstepButton?.addEventListener('click', this.handleCartItemRemove);
      this.scrollableEl?.addEventListener('touchmove', this.touchMove);
  
      this.closeButtons.forEach(button => button?.addEventListener('click', this.close));
      if (this.overlayEl) {
        this.overlayEl?.addEventListener('click', this.close);
      }

      [this.quantityMinusButton, this.quantityPlusButton].forEach(button => {
        button?.addEventListener('click', this.handleQuantitySelector)
      });
    }

    touchMove() {
      disableBodyScroll(false, '[data-scrollable]');
    }

    updateCartQuantity() {
      let _this = this;
      clearTimeout(this.addToCartDebounceTimer);

      if (this.quantity === this.prevPowerstepQuantity) return;

      this.addToCartDebounceTimer = setTimeout(() => {
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        fetch(location.origin + '/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            updates: {
              [this.variant.key]: this.quantity
            }
          })
        }).then(response => {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));

          if (response.ok) {
            
            const detail = {
              variant: this.powerStepData?.current_variant || this.variant || null,
              quantity: parseInt(this.quantitySelectorEl.querySelector('[name="quantity"]') ? this.quantitySelectorEl.querySelector('[name="quantity"]').value : this.quantitySelectorEl.querySelector('[name="items[0][quantity]"]').value),
              powerStepData: this.powerStepData ? this.powerStepData : null
            }

            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail
            }));

          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement('span');
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
              errorMessageElement.innerHTML = content['description'];
  
              _this.powerstepControls?.insertAdjacentElement('afterend', errorMessageElement);
  
              setTimeout(function () {
                errorMessageElement.remove();
              }, 10000);
            });
          }
        })
      }, this.debounceDelay);
    }

    handleQuantitySelector(event) {
      event.preventDefault();

      const button = event.target;
      const action = button.dataset?.action;

      if (action === 'quantity-minus' && this.quantity > 1) {
        this.quantity = this.quantity - 1;
      } else if (action === 'quantity-plus') {
        this.quantity = this.quantity + 1;
      }

      this.quantityEl.textContent = this.quantity;
      this.quantityEl.value = this.quantity;

      this.updateCartQuantity();
    } 

    addToCart(event, form) {
      event.preventDefault(); 

      var addToCartButton = event.target.closest('.ProductForm__AddToCart') || event.target;

      // First, we switch the status of the button
      addToCartButton?.setAttribute('disabled', 'disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      var formElement = form || event.target.parentNode.closest("form");

      const powerstepScriptElement = formElement.querySelector('.powerstep-data');
      let powerstepDataObject;
      if (powerstepScriptElement) {
        const jsonString = powerstepScriptElement.textContent;
        powerstepDataObject = JSON.parse(jsonString);
      }

      var formData = new FormData(formElement);

      fetch('/cart/add.js', {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        if (response.ok) {
          addToCartButton.removeAttribute('disabled');

          // We simply trigger an event so the mini-cart can re-render
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: powerstepDataObject ? powerstepDataObject.current_variant : null,
              quantity: parseInt(formElement.querySelector('[name="quantity"]') ? formElement.querySelector('[name="quantity"]').value : formElement.querySelector('[name="items[0][quantity]"]').value),
              powerStepData: powerstepDataObject ? powerstepDataObject : null
            }
          }));
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('span');
            errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
            errorMessageElement.innerHTML = content['description'];

            addToCartButton.removeAttribute('disabled');

            const cardFooter = addToCartButton.closest('.customreview_box-name');

            cardFooter.insertAdjacentElement('afterend', errorMessageElement);

            setTimeout(function () {
              errorMessageElement.remove();
            }, 10000);
          });
        }
      });

      event.preventDefault();
    }

    async handleProductAdded(event) {
      const detail = event.detail;
      this.powerStepData = detail?.powerStepData;
      this.variant = this.powerStepData?.current_variant || detail?.current_variant;
      this.product = this.powerStepData?.current_product;
      this.featuredImage = this.powerStepData?.featured_image || this.variant?.featured_image;

      // 1. Check if we have powerstep data.
      if (
          !this.powerStepData || 
          !this.powerStepData.powerstep_products?.length 
          || !this.powerStepData.powerstep_heading
      ) {
        console.log('No powerstep data, aborting');
        this.close();
        return;
      }

      // 2. Open the modal and set a loading state.
      if (!this.hasAttribute('open')) this.open();
        
      // 3. Populate the the main item section.
      await this.updateAddedItem();
      
      // 4. Update free shipping progress
      this.updateProgress();
      
      // 5. Update the recommendations section.
      if (
        this.product.handle !== this.prevPowerstepProduct?.handle 
        || event.type !== 'powerstep-modal:build') this.updateRecommendations();

      this.prevPowerstepProduct = this.product;
    }

    updateProgress() {
      if (!this.freeShippingThreshold) return;

      this.progressFill = (this.cartTotal / this.freeShippingThreshold) * 100;
      if (this.progressFill > 100) this.progressFill = 100;

      this.progressBarFillEl.style.width = `${this.progressFill}%`;

      if (this.progressFill >= 100) {
        this.progressBarInfo.textContent = this.progressBarInfo.dataset.full;
      } else {
        this.progressBarInfo.textContent = '';
        
        this.progressBarInfo.insertAdjacentHTML(
          'afterbegin',
          this.progressBarInfo.dataset.notFull.replace(
            '{{ shipping_difference }}', this.freeShippingThreshold - this.cartTotal
          )
        );
      }
    }

    async updateRecommendations() {
      this.recommendationsHeading.innerHTML = "";
      this.recommendationsSlider.innerHTML = "";
      
      this.setLoading(true);

      const response = await fetch(`${location.origin}/products/${this.product.handle}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');

      const powerstepRecommendations = doc.querySelector('.powerstep-slider');

      if (!powerstepRecommendations) {
        console.error('No recommendations found');
        this.setLoading(false);
        this.close();
        return;
      }

      this.recommendationsHeading.textContent = this.powerStepData.powerstep_heading;

      this.recommendationsSlider.insertAdjacentHTML('afterbegin', powerstepRecommendations.innerHTML);

      initSlickOnce(this);
      this.setPowerstepButtonListeners();
      this.setLoading(false);
    }

    setPowerstepButtonListeners() {
      this.recommendationsSlider.querySelectorAll('.ProductItem__Add').forEach(button => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.addToCart(event);
        });
      });
    }

    async updateAddedItem() {
      let cart;

      try {
        const r = await fetch('/cart.js');
        if (!r.ok) throw new Error('Failed to fetch cart:', r.status);
        cart = await r.json();
      } catch (err) {
        console.error(err);
        return;
      }
      
      const cartItem = cart.items.find(item => item.variant_id === this.variant.id);
      this.cartCount = cart.item_count;
      this.cartTotal = Math.round(cart.total_price / 100);
      this.variant.key = cartItem?.key;
      this.quantity = cartItem?.quantity;
      this.prevPowerstepQuantity = cartItem?.quantity;

      // Render cart info section in powerstep
      this.renderCartInfo();
      // Render main item section in powerstep
      this.renderAddedItem();
    }

    renderCartInfo() {
      const cartQuantityEl = this.querySelector('.powerstep__cart-quantity');
      const cartTotalEl = this.querySelector('.powerstep__cart-total');

      cartQuantityEl.textContent = `(${this.cartCount})`;
      cartTotalEl.textContent = `${this.cartTotal},-`;
    }

    renderAddedItem() {
      // update product content
      this.imageEl.src = this.featuredImage;
      this.imageEl.srcset = `${this.featuredImage} 150w`;
      this.titleEl.textContent = this.variant.name;
      this.priceEl.textContent = Math.round(this.variant.price / 100) + ',-';
      this.quantityEl.textContent = this.quantity;

      // update form data
      this.quantityInput.value = this.quantity;
      this.productIdInput.value = this.product.id;
      this.variantIdInput.value = this.variant.id;
      this.selectorPowerstepScript.textContent = JSON.stringify(this.powerStepData);
    }
    
    handleCartItemRemove() {
      this.removeItemCartButton = document.querySelector(
        `.Drawer__Content .Cart__ItemList [data-product-id="${this.variant.id}"] .CartItem__Remove`
      );

      if (!this.removeItemCartButton) return;

      this.removeItemCartButton.click();
      this.close();
      setTimeout(() => {
        document.querySelector('[data-drawer-id="sidebar-cart"][data-action="close-drawer"]')?.click();
      }, 1000);
    }

    setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
    }

    open() {
      this.setAttribute('open', 'true');
      document.body.style.overflow = 'hidden';
      disableBodyScroll(false, '[data-scrollable]');
      document.body.classList.add('powerstep-on');
    }

    close(e, type) {
      e?.preventDefault();

      document.body.style.overflow = '';
      this.removeAttribute('open');

      if (type === 'close-cart') {
        const overlayEl = document.querySelector('.PageOverlay.is-visible');
        overlayEl?.click();
      }
      document.body.classList.remove('powerstep-on');
    }
  }
  customElements.define('powerstep-modal', PowerstepModal);
} 

if (!document.querySelector('powerstep-modal')) {
  document.addEventListener('product:added', handleProductAddedWhenNoPowerstep);
}

async function handleProductAddedWhenNoPowerstep(event) {
  if (document.querySelector('powerstep-modal')) {
    document.removeEventListener('product:added', handleProductAddedWhenNoPowerstep);
    return;
  }

  const productHandle = event.detail.powerStepData?.current_product?.handle;
  if (!productHandle) return;

  const response = await fetch(`${location.origin}/products/${productHandle}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const htmlText = await response.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlText, 'text/html');

  const powerstepModal = doc.querySelector('powerstep-modal');
  const powerstepDataEl = doc.querySelector('.powerstep-data');
  powerstepDataEl.classList.add('is-loading');

  let powerstepDataObject;
  if (powerstepDataEl) {
    const jsonString = powerstepDataEl.textContent;
    powerstepDataObject = JSON.parse(jsonString);
  }
  if (!powerstepModal 
    || !powerstepDataObject?.powerstep_products?.length
    || !powerstepDataObject?.powerstep_heading
  ) return;

  powerstepModal.setAttribute('open', 'true');
  document.body.appendChild(powerstepModal);
  initSlickOnce(powerstepModal);

  powerstepDataEl.classList.remove('is-loading');

  
  document.dispatchEvent(new CustomEvent('powerstep-modal:build', {
    detail: {
      variant: powerstepDataObject?.current_variant || null,
      quantity: parseInt(event.detail.quantity),
      powerStepData: powerstepDataObject ? powerstepDataObject : null
    }
  }));
}